import { useEffect, useState } from "react";
import Modal from "../components/Modal";
import ReservationForm from "../components/ReservationForm";
import PaiementForm from "../components/PaiementForm";
import ModifierSejourModal from "../components/ModifierSejourModal";
import HistoriqueModal from "../components/HistoriqueModal";
import ModifierReservationModal from "../components/ModifierReservationModal";
import api from "../api";
import CheckinModal from "../components/CheckinModal";
import GenerateInvoiceModal from "../components/GenerateInvoiceModal";

import { History } from "lucide-react";

import { useNavigate } from "react-router-dom";

import {
  formatDate,
  toInputDate,
  toDate,
  isToday,
  isTomorrow
} from "../utils/dateUtils";

import {
    FaEdit,
    FaEye,
    FaPrint,
    FaDownload
} from "react-icons/fa";

function AppartementDetail() {
  const [data, setData] = useState(null);
  const [showReservation, setShowReservation] = useState(false);
  const [showPaiement, setShowPaiement] = useState(false);
  const [showEditReservation, setShowEditReservation] = useState(false);
  const [showEditSejour, setShowEditSejour] = useState(false);
  const [showHistorique, setShowHistorique] = useState(false);
  const [historique, setHistorique] = useState([]);
  const [loadingHistorique, setLoadingHistorique] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [calendar, setCalendar] = useState([]);
  const [selectedStart, setSelectedStart] = useState(null);
  const [selectedEnd, setSelectedEnd] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showCheckin, setShowCheckin] = useState(false);
  const [checkinReservation, setCheckinReservation] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [facturesSejour, setFacturesSejour] = useState({});

  const navigate = useNavigate();

  const token = localStorage.getItem("accessToken");
  const appartement = JSON.parse(localStorage.getItem("selectedAppartement"));

  const normalizeDate = (d) => toInputDate(d);

  const handleViewInvoice = (facture) => {

    if (!facture?.pdf_path) return;

    window.open(
      `${window.location.origin}${facture.pdf_path}`,
      "_blank"
    );

  };

  const handlePrintInvoice = (facture) => {

    console.log("Imprimer", facture);

    if (!facture?.pdf_path) return;

    const win = window.open(
      `${window.location.origin}${facture.pdf_path}`,
      "_blank"
    );

    if (win) {

      win.onload = () => win.print();

    }

  };

  const handleDownloadInvoice = (facture) => {

    console.log("Télécharger", facture);

    if (!facture?.pdf_path) return;

    const link = document.createElement("a");

    link.href = `${window.location.origin}${facture.pdf_path}`;

    link.download = facture.numero + ".pdf";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

  };

  const loadData = async () => {
    try {
      const res = await api.get(`/appartements/${appartement.id}`);

      console.log("DETAIL APPART =", res.data);
      
      setData(res.data);

      const res2 = await api.get(`/sejours/appartement/${appartement.id}`);
      setReservations(res2.data);

      await loadFactures(res2.data);

      console.log(res2.data);

    } catch (err) {
        console.error("DETAIL ERROR", err);
        console.error("DETAIL RESPONSE", err.response?.data);
      }
  };

  const loadFactures = async (sejours) => {

      const map = {};

      await Promise.all(

          sejours.map(async (s) => {

              try {

                  const { data } = await api.get(
                      `/factures/sejour/${s.id}`
                  );

                  map[s.id] = data.facture;

              } catch (err) {

                  if (err.response?.status !== 404) {

                      console.error(err);

                  }

              }

          })

      );

      setFacturesSejour(map);

  };

  const handleOpenHistorique = () => {
    navigate(`/appartement/${appartement.id}/historique`);
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (isDragging) {
      document.body.style.userSelect = "none";
      document.body.style.touchAction = "none"; // 🔥 important mobile
    } else {
      document.body.style.userSelect = "auto";
      document.body.style.touchAction = "auto";
    }

    return () => {
      document.body.style.userSelect = "auto";
      document.body.style.touchAction = "auto";
    };
  }, [isDragging]);

  useEffect(() => {
    if (!appartement?.id) return;

    const start = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    const end = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);

    const startStr = toInputDate(start);
    const endStr = toInputDate(end);

    api.get(`/sejours/availability/${appartement.id}?start=${startStr}&end=${endStr}`)
      .then(res => res.data)
      .then(data => {
        const fixed = data.map(d => ({
          ...d,
          date: d.date
        }));
        setCalendar(fixed);
      })
      .catch(err => console.error(err));

  }, [currentMonth, appartement?.id]);

  const totalSejour = Number(data?.total_sejour || 0);
  const totalPaye = Number(data?.total_paye || 0);
  const reste = Math.max(0, totalSejour - totalPaye);

  if (!data) return <p className="text-center p-6">Chargement...</p>;

  const today = new Date();
  today.setHours(0,0,0,0);

  const dateFinSource = data.date_fin_reelle || data.date_fin_prevue;

  let isExpired = false;
  let joursSupp = 0;

  if (dateFinSource) {
    const dateFin =   toDate(dateFinSource);

    if (!isNaN(dateFin)) {
      dateFin.setHours(0,0,0,0);

      isExpired = today > dateFin;

      if (isExpired) {
        const diff = today - dateFin;
        joursSupp = Math.ceil(diff / (1000 * 60 * 60 * 24));
      }
    }
  }

  const isExpire = data.statut === "expire";

  const isOccupe = data?.statut_reel === "en-cours";

  const prixApplique = data?.prix_nuitee_applique || data?.prix_nuitee || 0;

  let totalAjuste = totalSejour;
  let resteAjuste = reste;

  if (!isExpire && isExpired && joursSupp > 0) {
    const prix = Number(prixApplique || 0);

    const supplement = joursSupp * prix;

    totalAjuste = totalSejour + supplement;
    resteAjuste = Math.max(0, totalAjuste - totalPaye);
  }

  const isModifiedPrice =
    isOccupe &&
    data?.prix_nuitee_applique &&
    data?.prix_nuitee_applique !== data?.prix_nuitee;

  const handleReservation = () => {
    setShowReservation(true);
  };

  const isLibre = data?.statut_reel === "libre";
  const isReserve = data?.statut_reel === "reserve";

  const handleCloturer = async () => {
    if (reste > 0) return;

    const confirm = window.confirm("Clôturer ce séjour ?");
    if (!confirm) return;

    try {
      const res = await api.post(
        `/sejours/terminer/${data.sejour_id}`
      );

      const dataRes = res.data;

      if (dataRes.trop_percu > 0) {
        alert(`Séjour clôturé.\n⚠️ Trop-perçu : ${dataRes.trop_percu}$`);
      } else {
        alert("Séjour clôturé");
      }

      loadData();

    } catch (err) {
      console.error(err);

      alert(
        err?.response?.data?.error ||
        "Erreur serveur"
      );
    }
  };

  const groupCalendar = (calendar) => {
    if (!calendar || calendar.length === 0) return [];

    const groups = [];
    let current = {
      statut: calendar[0].statut,
      start: calendar[0].date,
      end: calendar[0].date,
      length: 1
    };

    for (let i = 1; i < calendar.length; i++) {
      const d = calendar[i];

      if (d.statut === current.statut) {
        current.end = d.date;
        current.length++;
      } else {
        groups.push(current);
        current = {
          statut: d.statut,
          start: d.date,
          end: d.date,
          length: 1
        };
      }
    }

    groups.push(current);
    return groups;
  };

  const grouped = groupCalendar(calendar);

  const handleSelectDate = (date) => {
    const day = calendar.find(d => normalizeDate(d.date) === normalizeDate(date))

    if (!day) return;

    if (day.statut === "occupe" || day.statut === "reserve") {
      const resa = reservations.find(r =>
        normalizeDate(r.date_debut) <= normalizeDate(date) &&
        normalizeDate(r.date_fin_prevue) > normalizeDate(date)
      );

      if (resa) {
        setSelectedReservation(resa);
        setShowEditReservation(true);
      }

      return;
    }

    if (!selectedStart) {
      setSelectedStart(date);
      setSelectedEnd(null);
      return;
    }

    if (!selectedEnd) {
      if (toDate(date) < toDate(selectedStart)) {
        setSelectedStart(date);
      } else {
        setSelectedEnd(date);
      }
      return;
    }

    setSelectedStart(date);
    setSelectedEnd(null);
  };

  const isRangeValid = (start, end) => {
    if (!start || !end) return true;

    return !calendar.some(d => {
      const date = toDate(d.date);
      return (
        date >= toDate(start) &&
        date <= toDate(end) &&
        (d.statut === "occupe" || d.statut === "reserve")
      );
    });
  };

  const isValidSelection = isRangeValid(selectedStart, selectedEnd);

  // ==========================================
  // 📋 RÉSERVATIONS AFFICHÉES DANS L'APPARTEMENT
  // ==========================================

  const reservationsVisibles = reservations.filter(
    (r) =>
      r.statut !== "annule" &&
      r.statut !== "termine"
  );

  const handleMouseDown = (date) => {
    const day = calendar.find(d => normalizeDate(d.date) === normalizeDate(date))
    if (!day) return;

    const isBlocked = day.statut === "occupe" || day.statut === "reserve";

    if (isBlocked) {
      const resa = reservations.find(r =>
        normalizeDate(r.date_debut) <= normalizeDate(date) &&
        normalizeDate(r.date_fin_prevue) > normalizeDate(date)
      );

      if (resa) {
        setSelectedReservation(resa);
        setShowEditReservation(true);
      }

      return;
    }

    setSelectedStart(date);
    setSelectedEnd(null);
    setIsDragging(true);
  };

  const handleMouseEnter = (date) => {
    if (!isDragging || !selectedStart) return;

    const day = calendar.find(d => normalizeDate(d.date) === normalizeDate(date))
    if (!day) return;

    const isBlocked = day.statut === "occupe" || day.statut === "reserve";
    if (isBlocked) return;

    if (toDate(date) < toDate(selectedStart)) {
      setSelectedEnd(selectedStart);
      setSelectedStart(date);
    } else {
      setSelectedEnd(date);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);

    if (selectedStart && !selectedEnd) {
      const nextDay = toDate(selectedStart);
      nextDay.setDate(nextDay.getDate() + 1);
      setSelectedEnd(toInputDate(nextDay));
    }
  };
      

  const getTouchDate = (touchEvent) => {
    const touch = touchEvent.touches[0];
    const el = document.elementFromPoint(touch.clientX, touch.clientY);

    if (!el) return null;

    return el.getAttribute("data-date");
  };

  const handleTouchStart = (date) => {
    const day = calendar.find(d => normalizeDate(d.date) === normalizeDate(date))
    if (!day) return;

    const isBlocked = day.statut === "occupe" || day.statut === "reserve"; // ✅ AJOUT ICI

    if (isBlocked) {
      const resa = reservations.find(r =>
        normalizeDate(r.date_debut) <= normalizeDate(date) &&
        normalizeDate(r.date_fin_prevue) > normalizeDate(date)
      );

      if (resa) {
        setSelectedReservation(resa);
        setShowEditReservation(true);
      }

      return;
    }

    setSelectedStart(date);
    setSelectedEnd(null);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !selectedStart) return;

    const date = getTouchDate(e);
    if (!date) return;

    const day = calendar.find(d => normalizeDate(d.date) === normalizeDate(date))
    if (!day) return;

    const isBlocked = day.statut === "occupe" || day.statut === "reserve";
    if (isBlocked) return;

    if (toDate(date) < toDate(selectedStart)) {
      setSelectedEnd(selectedStart);
      setSelectedStart(date);
    } else {
      setSelectedEnd(date);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    if (selectedStart && !selectedEnd) {
      const nextDay = toDate(selectedStart);
      nextDay.setDate(nextDay.getDate() + 1);
      setSelectedEnd(toInputDate(nextDay));
    }
  };

  console.log(data);

  console.log("DATE_DEBUT RAW =", reservations[0]?.date_debut);
  console.log("DATE_FIN RAW =", reservations[0]?.date_fin_prevue);

    // ==========================================
    // 💱 AFFICHAGE MONÉTAIRE
    // ==========================================

    const formatMontant = (montant, devise = "USD") => {
      const valeur = Number(montant || 0);

      return `${valeur.toLocaleString("fr-FR")} ${devise}`;
    };

    const getDeviseFacture = (facture) => {
      return String(facture?.devise || "USD").toUpperCase();
    };

  return (

    <div className="p-3 md:p-6 max-w-5xl mx-auto space-y-4 min-h-[100dvh] bg-gray-100">

      <button
        onClick={() => window.history.back()}
        className="flex items-center gap-2 bg-white shadow px-4 py-3 rounded-2xl hover:bg-gray-100 transition w-fit"
      >
        ← <span className="font-medium">Retour</span>
      </button>

      <h2 className="text-2xl md:text-3xl font-bold text-center">

        {data.type_logement === "chambre"
          ? "Chambre"
          : data.type_logement === "suite"
          ? "Suite"
          : "Appartement"}{" "}

        {data.numero}

      </h2>

      <div className="bg-white rounded-3xl shadow-lg p-4 md:p-6 space-y-5">

        <p><b>État :</b> {data.statut_reel}</p>

        <p><b>Client :</b> {data.client || "-"}</p>

        <p>
          <b>Prix standard :</b>{" "}
          {data.prix_nuitee
            ? `${data.prix_nuitee}$`
            : "-"}
        </p>

        <hr />

        {/* ========================= */}
        {/* 📅 CALENDRIER */}
        {/* ========================= */}

        <div className="bg-gray-50 rounded-2xl border p-4 mt-4 overflow-hidden">

          <div className="flex justify-between items-center mb-3">

            <button
              onClick={() => {
                const prev = new Date(
                  currentMonth.getFullYear(),
                  currentMonth.getMonth() - 1,
                  1
                );

                const today = new Date();

                const firstDayCurrent = new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  1
                );

                if (prev < firstDayCurrent) return;

                setCurrentMonth(prev);
              }}
              className="px-3 py-1 bg-gray-200 rounded"
            >
              ←
            </button>

            <span className="font-semibold">
              {currentMonth.toLocaleString("fr-FR", {
                month: "long",
                year: "numeric"
              })}
            </span>

            <button
              onClick={() =>
                setCurrentMonth(
                  new Date(
                    currentMonth.getFullYear(),
                    currentMonth.getMonth() + 1,
                    1
                  )
                )
              }
              className="px-3 py-1 bg-gray-200 rounded"
            >
              →
            </button>

          </div>

          <h3 className="font-semibold mb-3">
            📅 Calendrier
          </h3>

          {/* 🔥 NOUVELLE GRID */}
          <div
            className="flex gap-1 overflow-x-auto pb-2"
            onMouseLeave={() => setIsDragging(false)}
          >

            {calendar.map((d, i) => {

              let color = "bg-green-400";

              if (d.statut === "occupe") color = "bg-red-500";

              if (d.statut === "reserve") color = "bg-yellow-400";

              const isSelected =
                selectedStart &&
                selectedEnd &&
                toDate(d.date) >= toDate(selectedStart) &&
                toDate(d.date) < toDate(selectedEnd);

              const isStart =
                selectedStart &&
                normalizeDate(selectedStart) === normalizeDate(d.date);

              const isEnd =
                selectedEnd &&
                normalizeDate(selectedEnd) === normalizeDate(d.date);

              const isBlocked =
                d.statut === "occupe" ||
                d.statut === "reserve";

              return (

                <div
                  key={i}
                  data-date={d.date}

                  onMouseDown={() => handleMouseDown(d.date)}
                  onMouseEnter={() => handleMouseEnter(d.date)}
                  onMouseUp={handleMouseUp}

                  onTouchStart={() => handleTouchStart(d.date)}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}

                  onClick={() =>
                    !isDragging && handleSelectDate(d.date)
                  }

                  title={
                    isBlocked
                      ? "Cliquer pour modifier la réservation"
                      : "Cliquer et glisser pour réserver"
                  }

                  className={`
                    min-w-[34px] h-[34px]
                    flex items-center justify-center
                    text-xs font-semibold text-white select-none
                    rounded-lg
                    ${color}
                    ${isSelected ? "bg-blue-600" : ""}
                    ${isStart ? "ring-4 ring-black" : ""}
                    ${isEnd ? "ring-4 ring-black" : ""}
                    cursor-pointer
                  `}
                >

                  {toDate(d.date).getDate()}

                </div>
              );
            })}

          </div>

        </div>

        {/* ========================= */}
        {/* 📅 SELECTION */}
        {/* ========================= */}

        {selectedStart && selectedEnd && (

          <div className="text-sm text-green-600">

            ✔ {selectedStart} → {selectedEnd}

          </div>

        )}

        {/* ========================= */}
        {/* 📋 RESERVATIONS */}
        {/* ========================= */}

        <div className="space-y-3">

          <h3 className="text-lg font-bold">
            📋 Réservations
          </h3>

          {reservations.length === 0 ? (

            <div className="bg-gray-50 border rounded-2xl p-4 text-gray-500">
              Aucune réservation
            </div>

          ) : (

            reservationsVisibles.map((r) => {

              const isOccupeNow =
                r.statut === "occupe";

              const isReserveNow =
                r.statut === "reserve" ||
                r.statut === "confirme";

              const arriveePossible =
                (r.statut === "reserve" ||
                 r.statut === "confirme") &&
                toDate(r.date_debut) <= new Date();

              const facture = facturesSejour[r.id];

              const factureSoldee =
                  facture &&
                  Number(facture.reste_a_payer) <= 0;
              
              const factureExiste = !!facture;

              return (

                <div
                  key={r.id}
                  className="bg-white border rounded-2xl p-4 shadow-sm space-y-2"
                >

                  <div className="flex justify-between items-start gap-3">

                    <div>

                      <div className="font-bold text-lg">
                        {r.client || "Client"}
                      </div>

                      <div className="text-sm text-gray-500">
                        {formatDate(r.date_debut)} →{" "}
                        {formatDate(r.date_fin_prevue)}
                      </div>

                      {r.statut === "reserve" && isToday(r.date_debut) && (
                        <div className="text-green-600 text-xs font-semibold mt-1">
                          🟢 Arrivée aujourd'hui
                        </div>
                      )}

                    </div>

                    <div
                      className={`px-3 py-1 rounded-full text-sm text-white ${
                        isOccupeNow
                          ? "bg-red-500"
                          : isReserveNow
                          ? "bg-yellow-500"
                          : "bg-gray-500"
                      }`}
                    >
                      {r.statut}
                    </div>

                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-sm">

                      <div>
                          <b>Total :</b><br />
                          {facture
                              ? formatMontant(
                                  facture.montant_total,
                                  getDeviseFacture(facture)
                              )
                              : formatMontant(
                                  r.total_sejour,
                                  "USD"
                              )
                          }
                      </div>

                      <div>
                          <b>Payé :</b><br />
                          {facture
                              ? formatMontant(
                                  facture.montant_paye,
                                  getDeviseFacture(facture)
                              )
                              : formatMontant(
                                  r.total_paye,
                                  "USD"
                              )
                          }
                      </div>

                      <div>
                          <b>Reste :</b><br />
                          {facture
                              ? formatMontant(
                                  facture.reste_a_payer,
                                  getDeviseFacture(facture)
                              )
                              : formatMontant(
                                  (r.total_sejour || 0) - (r.total_paye || 0),
                                  "USD"
                              )
                          }
                      </div>

                      <div>
                          <b>Prix appliqué :</b><br />
                          {formatMontant(
                              r.prix_nuitee_applique || r.prix_nuitee || 0,
                              "USD"
                          )}
                      </div>

                      <div>
                        <b>Occupation :</b><br />

                        {
                          !r.type_occupation
                            ? "-"

                            : r.type_occupation === "individuel"
                              ? "Individuel"

                              : r.type_occupation === "couple"
                                ? "Couple"

                                : `${r.type_occupation.charAt(0).toUpperCase()}${r.type_occupation.slice(1)} (${r.nombre_occupants || 0} personnes)`
                        }

                      </div>

                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mt-4">

                      {/* ========================= */}
                      {/* 🧾 FACTURE */}
                      {/* ========================= */}

                      <div className="bg-white rounded-xl shadow border border-gray-200">

                          <div className="mt-4 bg-white rounded-xl shadow border border-gray-200">

                            {/* En-tête */}

                            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b rounded-t-xl">

                                <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">

                                    🧾 Facture

                                </h3>

                                {facturesSejour[r.id] && (

                                    <span className="text-sm font-medium text-blue-700">

                                        {facturesSejour[r.id].numero}

                                    </span>

                                )}

                            </div>

                            <div className="p-4">

                                {!facturesSejour[r.id] ? (

                                    <>
                                        <p className="text-gray-500 mb-4">
                                            Aucune facture n'a encore été générée pour ce séjour.
                                        </p>

                                        <button
                                            onClick={() => {
                                                setSelectedReservation(r);
                                                setShowInvoiceModal(true);
                                            }}
                                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
                                        >
                                            <FaEdit />
                                            Générer la facture
                                        </button>
                                    </>

                                ) : (

                                    <>

                                    

                                        {/* Résumé */}

                                        <div className="grid grid-cols-2 gap-4 mb-5">

                                            <div className="bg-gray-50 rounded-lg p-3">

                                                <div className="text-xs text-gray-500 uppercase">

                                                    Montant total

                                                </div>

                                                <div className="text-lg font-semibold">
                                                    {formatMontant(
                                                        facture.montant_total,
                                                        getDeviseFacture(facturesSejour[r.id])
                                                    )}
                                                </div>

                                            </div>

                                            <div className="bg-gray-50 rounded-lg p-3">

                                                <div className="text-xs text-gray-500 uppercase">

                                                    Déjà payé

                                                </div>

                                                <div className="text-lg font-semibold text-green-600">
                                                    {formatMontant(
                                                        facture.montant_paye,
                                                        getDeviseFacture(facturesSejour[r.id])
                                                    )}
                                                </div>

                                            </div>

                                            <div className="bg-gray-50 rounded-lg p-3">

                                                <div className="text-xs text-gray-500 uppercase">

                                                    Reste à payer

                                                </div>

                                                <div className="text-lg font-semibold text-red-600">
                                                    {formatMontant(
                                                        facture.reste_a_payer,
                                                        getDeviseFacture(facturesSejour[r.id])
                                                    )}
                                                </div>

                                            </div>

                                            <div className="bg-gray-50 rounded-lg p-3">

                                                <div className="text-xs text-gray-500 uppercase">

                                                    Statut

                                                </div>

                                                <div className="text-lg font-semibold text-blue-700">

                                                    {facturesSejour[r.id].statut}

                                                </div>

                                            </div>

                                        </div>

                                        {/* Boutons */}
                                        <div className="mt-4">

                                            {/* Actions sur la facture */}
                                            <div className="flex flex-wrap gap-2">

                                                <button
                                                    onClick={() => {
                                                        setSelectedReservation(r);
                                                        setShowInvoiceModal(true);
                                                    }}
                                                    className="flex items-center gap-2 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
                                                >
                                                    <FaEdit />
                                                    Modifier
                                                </button>

                                                <button
                                                    onClick={() => {
                                                        console.log("PRINT FACTURE =", facture);
                                                        handlePrintInvoice(facture);
                                                    }}
                                                    className="flex items-center gap-2 px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
                                                >
                                                    <FaPrint />
                                                    Imprimer
                                                </button>

                                                <button
                                                    onClick={() => {
                                                        console.log("DOWNLOAD FACTURE =", facture);
                                                        handleDownloadInvoice(facture);
                                                    }}
                                                    className="flex items-center gap-2 px-3 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg"
                                                >
                                                    <FaDownload />
                                                    Télécharger
                                                </button>

                                            </div>

                                            {/* Séparation */}
                                            <div className="border-t mt-4 pt-4">

                                                <button
                                                    onClick={() => {

                                                        if (!factureExiste || factureSoldee) return;

                                                        setSelectedReservation(r);
                                                        setShowPaiement(true);

                                                    }}

                                                    disabled={!factureExiste || factureSoldee}

                                                    className={`
                                                        w-full py-2 rounded-lg text-white transition
                                                        ${
                                                            !factureExiste
                                                                ? "bg-gray-400 cursor-not-allowed"
                                                                : factureSoldee
                                                                    ? "bg-green-300 cursor-not-allowed"
                                                                    : "bg-green-600 hover:bg-green-700"
                                                        }
                                                    `}
                                                >
                                                    {
                                                        !factureExiste
                                                            ? "🧾 Générer d'abord la facture"
                                                            : factureSoldee
                                                                ? "✅ Facture soldée"
                                                                : "💳 Payer la facture"
                                                    }
                                                </button>

                                            </div>

                                        </div>

                                    </>

                                )}

                            </div>

                        </div>

                      </div>

                      {/* ========================= */}
                      {/* ⚙️ ACTIONS DU SÉJOUR */}
                      {/* ========================= */}

                      <div className="bg-white rounded-xl shadow border border-gray-200">

                          <div className="px-4 py-3 bg-gray-50 border-b rounded-t-xl">

                              <h3 className="text-lg font-semibold">
                                  ⚙️ Actions du séjour
                              </h3>

                          </div>

                          <div className="p-4 space-y-3">

                              {/* ✏️ MODIFIER RÉSERVATION */}

                              {(r.statut === "reserve" ||
                                r.statut === "confirme") && (
                                  <button
                                      onClick={() => {
                                          setSelectedReservation(r);
                                          setShowEditReservation(true);
                                      }}
                                      className="w-full py-3 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
                                  >
                                      Modifier la réservation
                                  </button>
                              )}

                              {/* 🚪 ARRIVÉE */}

                              {arriveePossible && (
                                  <button
                                      onClick={() => {
                                          setCheckinReservation(r);
                                          setShowCheckin(true);
                                      }}
                                      className="w-full py-3 rounded-lg bg-green-600 text-white hover:bg-blue-700"
                                  >
                                      Arrivée
                                  </button>
                              )}

                              {/* 🛏️ SÉJOUR */}

                              {(r.statut === "en_cours" || r.statut === "expire") && (
                                  <button
                                      onClick={() => {
                                          setSelectedReservation(r);
                                          setShowEditSejour(true);
                                      }}
                                      className="w-full py-3 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
                                  >
                                      🛏️ Gérer le séjour
                                  </button>
                              )}

                          </div>

                      </div>

                  </div>

                </div>
              );
            })

          )}

        </div>

        {/* ========================= */}
        {/* ACTIONS */}
        {/* ========================= */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">

          {/* ➕ RÉSERVER */}
          <button

            onClick={() => {

              if (!selectedStart) {

                alert(
                  "Clique et fais glisser sur le calendrier pour choisir les dates"
                );

                return;
              }

              let end = selectedEnd;

              if (!end && selectedStart) {

                const nextDay = toDate(selectedStart);

                nextDay.setDate(nextDay.getDate() + 1);

                end = toInputDate(nextDay);

                setSelectedEnd(end);
              }

              if (!isValidSelection) {

                alert(
                  "Certaines dates ne sont pas disponibles"
                );

                return;
              }

              setShowReservation(true);

            }}

            className="py-3 rounded-lg text-white bg-blue-600 hover:bg-blue-700"
          >
            Réserver
          </button>

          {/* 📜 HISTORIQUE */}
          <button
            onClick={handleOpenHistorique}
            disabled={loadingHistorique}
            className={`py-3 rounded-lg text-white ${
              loadingHistorique
                ? "bg-gray-400"
                : "bg-gray-700 hover:bg-gray-800"
            }`}
          >
            {loadingHistorique
              ? "Chargement..."
              : "Historique"}
          </button>

        </div>

      </div>


      {/* ========================= */}
      {/* ➕ RESERVATION */}
      {/* ========================= */}

      {showReservation && (
        <Modal onClose={() => setShowReservation(false)}>
          <ReservationForm
            appartement={data}
            mode="create"
            dateDebut={selectedStart}
            dateFin={selectedEnd}
            onClose={() => {
              setShowReservation(false);
              loadData();
              setSelectedStart(null);
              setSelectedEnd(null);
            }}
          />
        </Modal>
      )}

      {/* ========================= */}
      {/* ✏️ MODIFIER SEJOUR */}
      {/* ========================= */}

      {showEditSejour && (
        <Modal onClose={() => setShowEditSejour(false)}>
          <ModifierSejourModal
            data={selectedReservation}
            onClose={() => {
              setShowEditSejour(false);
              loadData();
            }}
          />
        </Modal>
      )}

      {/* ========================= */}
      {/* 📜 HISTORIQUE */}
      {/* ========================= */}

      {showHistorique && (
        <Modal onClose={() => setShowHistorique(false)}>
          <HistoriqueModal
            data={historique}
            onClose={() => setShowHistorique(false)}
          />
        </Modal>
      )}

      {/* ========================= */}
      {/* ✏️ MODIFIER RESERVATION */}
      {/* ========================= */}

      {showEditReservation && selectedReservation && (
        <Modal onClose={() => setShowEditReservation(false)}>
          <ModifierReservationModal
            data={selectedReservation}
            onClose={() => {
              setShowEditReservation(false);
              loadData();
            }}
          />
        </Modal>
      )}

      {/* ========================= */}
      {/* 💳 PAIEMENT */}
      {/* ========================= */}

      {showPaiement && (
        <PaiementForm
          sejourId={selectedReservation?.id || data.sejour_id}
          montantInitial={
            selectedReservation
              ? Number(
                  facturesSejour[selectedReservation.id]?.reste_a_payer ?? 0
                )
              : 0
          }

          facture={
              selectedReservation
                  ? facturesSejour[selectedReservation.id]
                  : null
          }

          onClose={() => {
            setShowPaiement(false);
            loadData();
          }}
        />
      )}

      {showCheckin && checkinReservation && (
        <Modal onClose={() => setShowCheckin(false)}>
          <CheckinModal
            reservation={checkinReservation}
            onClose={() => {
              setShowCheckin(false);
              loadData();
            }}
          />
        </Modal>
      )}

      <GenerateInvoiceModal
          open={showInvoiceModal}
          sejour={selectedReservation}
          onClose={() => {

              setShowInvoiceModal(false);

              loadData();

          }}
      />

    </div>
  );
}

export default AppartementDetail;
